import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Add Url", -1)
const _hoisted_2 = { class: "form__line" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BorderedInput = _resolveComponent("BorderedInput")!
  const _component_ControlButtons = _resolveComponent("ControlButtons")!
  const _component_CustomModal = _resolveComponent("CustomModal")!

  return (_openBlock(), _createBlock(_component_CustomModal, {
    id: `editor-modal-link-${_ctx.id}`,
    modalClass: "custom-modal_margin-md",
    onOnOpened: _ctx.onOpened
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createElementVNode("form", {
        class: "form",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onActionEvent && _ctx.onActionEvent(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_BorderedInput, {
            id: "url",
            modelValue: _ctx.url,
            label: "Url",
            triggerFocus: _ctx.focusOnUrl,
            "onUpdate:modelValue": _ctx.handleInput
          }, null, 8, ["modelValue", "triggerFocus", "onUpdate:modelValue"])
        ])
      ], 32)
    ]),
    footer: _withCtx(({ hide }) => [
      _createVNode(_component_ControlButtons, {
        onSave: ($event: any) => (_ctx.onActionEvent(hide)),
        onCancel: hide
      }, {
        save: _withCtx(() => [
          _createTextVNode(" Continue ")
        ]),
        cancel: _withCtx(() => [
          _createTextVNode(" Close ")
        ]),
        _: 2
      }, 1032, ["onSave", "onCancel"])
    ]),
    _: 1
  }, 8, ["id", "onOnOpened"]))
}